import { AppError } from '@services/error-handler/error-handler.service';

export function createErrorObj(title = 'Error', message = ''): AppError {
  return {
    message: title,
    error: {
      errors: [{ msg: message }]
    }
  };
}
